import React, { Component } from 'react';
import styles from './CollectionItem.module.scss';
import {baseUrl} from '../../utils/utils.js';

class CollectionItem extends Component {
  
  render() {
    return (
      <div
        className={styles.itemContainer}
        onClick={() => this.props.handleClick(this.props.id, this.props.title)}
      >
        <img 
          src={baseUrl(`img/collections/${this.props.image}`)}
          alt={this.props.title}
        />
        <div className={styles.itemFooter}>
          <span className={styles.itemTitle}>
            {this.props.title}
          </span>
          <span className={styles.rightArrow}>
            &rarr;
          </span>
        </div>
      </div>
    );
  }
}

export default CollectionItem;